export default __webpack_public_path__ + "static/study-image02-c3f313309ad9aee66f24b0bce0b5b49e.jpg";